function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M83 104H23.793c-1.027 0-1.387-1.364-.493-1.87L50 87m33 17V51.599a1 1 0 01.528-.882L111 36m-28 68l27.511-16.365a1 1 0 00.489-.86V36M50 87V37a1 1 0 011-1h60M50 87h33",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82 52a20 20 0 100 40V52z",
  fill: "#A6A6A6"
});
function SvgOnboardingS1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgOnboardingS1;